import useTranslation from "../../hooks/useTranslation";

const TimelineStartEnd = ({ endTime }) => {
  const T = useTranslation();
  const colorGreenPrimary = "#2AAC9C";
  const colorGreenSecondary = "#BBDFDB";

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "4px",
        }}
      >
        <span>{T("startCase")}</span>
        <span>{T("endCase")}</span>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "white",
            borderWidth: 2,
            borderColor: colorGreenPrimary,
            height: "8px",
            width: "8px",
            borderRadius: "50%",
          }}
        />
        <div
          style={{
            dislay: "flex",
            flex: 1,
            height: "2px",
            backgroundColor: colorGreenSecondary,
          }}
        />
        <div
          style={{
            background: colorGreenPrimary,
            height: "8px",
            width: "8px",
            borderRadius: "50%",
          }}
        />
      </div>
    </div>
  );
};

export default TimelineStartEnd;
